import {Tag} from "antd";
import React from "react";

const ColoredTag = ({name, color})=>{
    return (
        <Tag style={{
            background: `linear-gradient(to right, ${color} 10%, #fff 10%)`,
            width: 60
        }}
             className={'shadow-sm'}>
            <span style={{paddingLeft: '5px', textTransform: 'capitalize', fontWeight: '600'}}>{name}</span>
        </Tag>
    )
}

export default ColoredTag;